// Images
import metamaskIcon from "assets/images/mm.png";
import walletConnectIcon from "assets/images/wc.png";
import coinbaseWalletIcon from "assets/images/cbw.png";
import okexWalletIcon from "assets/images/okex.png";
import ledgerIcon from "assets/images/LedgerLightIcon.png";
import ledgerDarkIcon from "assets/images/LedgerDarkIcon.png";
import coin98WalletIcon from "assets/images/coin98.png";
import safePalWalletIcon from "assets/images/safepal.jpeg";
import mathWalletIcon from "assets/images/mathWallet.png";
import trustWalletIcon from "assets/images/trustWallet.jpeg";
import kuwalletIcon from "assets/images/kuwallet.svg";
import bitkeepIcon from "assets/images/bitkeep.jpeg";
import zerionIcon from "assets/svg/zerion.svg";
import phantomIcon from "assets/images/phantom.png";
import exodusIcon from "assets/svg/exodus.svg";

// Types
import { IIndexable, WalletMenuOption } from "types/common";

export const walletIconMapping: IIndexable = {
  injected: {
    light: metamaskIcon,
    dark: metamaskIcon,
  },
  kuwallet: {
    light: kuwalletIcon,
    dark: kuwalletIcon,
  },
  coinbaseWallet: {
    light: coinbaseWalletIcon,
    dark: coinbaseWalletIcon,
  },
  walletConnect: {
    light: walletConnectIcon,
    dark: walletConnectIcon,
  },
  okex: {
    light: okexWalletIcon,
    dark: okexWalletIcon,
  },
  ledger: {
    light: ledgerIcon,
    dark: ledgerDarkIcon,
  },
  ledgerLive: {
    light: ledgerIcon,
    dark: ledgerDarkIcon,
  },
  coin98: {
    light: coin98WalletIcon,
    dark: coin98WalletIcon,
  },
  safepal: {
    light: safePalWalletIcon,
    dark: safePalWalletIcon,
  },
  mathwallet: {
    light: mathWalletIcon,
    dark: mathWalletIcon,
  },
  trustwallet: {
    light: trustWalletIcon,
    dark: trustWalletIcon,
  },
  bitkeep: {
    light: bitkeepIcon,
    dark: bitkeepIcon,
  },
  zerion: {
    light: zerionIcon,
    dark: zerionIcon,
  },
  phantom: {
    light: phantomIcon,
    dark: phantomIcon,
  },
  exodus: {
    light: exodusIcon,
    dark: exodusIcon,
  },
};

export const walletLabelMapping: IIndexable = {
  injected: "Metamask",
  kuwallet: "Kucoin",
  coinbaseWallet: "Coinbase Wallet",
  walletConnect: "Wallet Connect",
  okex: "OKX Wallet",
  ledger: "Ledger",
  ledgerLive: "Ledger Live",
  coin98: "Coin98 Wallet",
  safepal: "SafePal Wallet",
  mathwallet: "Math Wallet",
  trustwallet: "Trust Wallet",
  bitkeep: "BitKeep Wallet",
  zerion: "Zerion Wallet",
  phantom: "Phantom Wallet",
  exodus: "Exodus Wallet",
};

export const walletMenuOptions: WalletMenuOption[] = [
  {
    key: "injected",
    label: walletLabelMapping["injected"],
    icon: walletIconMapping["injected"],
    polygonSupport: true,
  },
  {
    key: "kuwallet",
    label: "Kucoin Wallet",
    icon: walletIconMapping["kuwallet"],
    polygonSupport: true,
  },
  {
    key: "walletConnect",
    label: walletLabelMapping["walletConnect"],
    icon: walletIconMapping["walletConnect"],
    polygonSupport: true,
  },
  {
    key: "coinbaseWallet",
    label: walletLabelMapping["coinbaseWallet"],
    icon: walletIconMapping["coinbaseWallet"],
    polygonSupport: true,
  },
  {
    key: "phantom",
    label: walletLabelMapping["phantom"],
    icon: walletIconMapping["phantom"],
    polygonSupport: true,
  },
  {
    key: "okex",
    label: walletLabelMapping["okex"],
    icon: walletIconMapping["okex"],
    polygonSupport: true,
  },
  {
    key: "ledger",
    label: walletLabelMapping["ledger"],
    icon: walletIconMapping["ledger"],
    polygonSupport: false,
  },
  {
    key: "coin98",
    label: walletLabelMapping["coin98"],
    icon: walletIconMapping["coin98"],
    polygonSupport: true,
  },
  {
    key: "safepal",
    label: walletLabelMapping["safepal"],
    icon: walletIconMapping["safepal"],
    polygonSupport: true,
  },
  {
    key: "mathwallet",
    label: walletLabelMapping["mathwallet"],
    icon: walletIconMapping["mathwallet"],
    polygonSupport: true,
  },
  {
    key: "trustwallet",
    label: walletLabelMapping["trustwallet"],
    icon: walletIconMapping["trustwallet"],
    polygonSupport: true,
  },
  {
    key: "bitkeep",
    label: walletLabelMapping["bitkeep"],
    icon: walletIconMapping["bitkeep"],
    polygonSupport: true,
  },
  {
    key: "exodus",
    label: walletLabelMapping["exodus"],
    icon: walletIconMapping["exodus"],
    polygonSupport: true,
  },
];

export const getWalletOptions = (isPolygonChainActive: boolean) => {
  let options = walletMenuOptions;

  if (isPolygonChainActive) {
    options = options.filter((item) => item.polygonSupport);
  }

  return options;
};
